var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-semi-circle-gauges-card"},[_c('p',[_vm._v("controller_type: LAMP_MTAP_1_V1")])])}]

export { render, staticRenderFns }